import * as React from 'react'

import { cn } from '@ui/lib/utils'
import { useFormField } from './form'

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

type InputState = 'default' | 'error'

const baseStyles =
  'flex w-full rounded-m px-s py-3.5 text-base text-gray-900 outline outline-1 ring-offset-white transition-all duration-200 ease-in-out file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-base placeholder:text-gray-400 placeholder:text-gray-500'

const enabledStyles =
  'enabled:hover:outline-2 enabled:focus-visible:text-gray-900 enabled:focus-visible:outline-2'

const disabledStyles =
  'disabled:bg-transparent disabled:text-gray-300 disabled:outline-gray-200 disabled:ring-0 disabled:ring-transparent disabled:placeholder:text-gray-300'

const getInputStyles = (state: InputState) => {
  switch (state) {
    case 'error':
      return 'bg-red-50 outline-red-500 enabled:hover:outline-red-500 enabled:focus-visible:outline-red-500'
    default:
      return 'outline-gray-200 enabled:hover:outline-gray-400 enabled:focus-visible:bg-gray-50 enabled:focus-visible:outline-blue-600'
  }
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const { error } = useFormField()

    return (
      <input
        type={type}
        className={cn(
          baseStyles,
          enabledStyles,
          disabledStyles,
          getInputStyles(error ? 'error' : 'default'),
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)

Input.displayName = 'Input'

export { Input }
